import { extendTheme } from "@chakra-ui/react";

// ============================================================================
// 🎨 GLOBAL MAIN COLOR CONFIGURATION
// Change this single constant to update the entire application theme!
// ============================================================================
export const MAIN_COLOR = "#8e2924"; // Mini 9th Album [Still] Theme Burgundy
export const MAIN_COLOR_HOVER = "#78221e";
export const MAIN_COLOR_ACTIVE = "#631b18";
export const MAIN_COLOR_LIGHT = "#fcf5f5";
export const MAIN_COLOR_SOFT = "rgba(142, 41, 36, 0.08)";
export const MAIN_COLOR_BORDER = "rgba(142, 41, 36, 0.18)";
export const MAIN_COLOR_SHADOW = "rgba(142, 41, 36, 0.25)";

const theme = extendTheme({
  colors: {
    // Override Chakra default 'purple' palette to synchronize with MAIN_COLOR
    purple: {
      50: "#fdf5f5",
      100: "#f9e1e0",
      150: "#f5d0ce",
      200: "#f1c2c0",
      300: "#e69996",
      400: "#cb5a54",
      500: MAIN_COLOR,
      600: MAIN_COLOR_HOVER,
      700: MAIN_COLOR_ACTIVE,
      750: "#551512",
      800: "#4f1714",
      900: "#3d110f",
    },
    brand: {
      main: MAIN_COLOR,
      hover: MAIN_COLOR_HOVER,
      active: MAIN_COLOR_ACTIVE,
      sub: "#c6cbcc",
      sub2: "#06B6D4",
      purpleLight: MAIN_COLOR_LIGHT,
      purpleSoft: MAIN_COLOR_SOFT,
      soft: MAIN_COLOR_SOFT,
      border: MAIN_COLOR_BORDER,
      glass: "rgba(255, 255, 255, 0.8)",
      bg: "#FAFAFE",
    },
  },
  shadows: {
    soft: "0 4px 18px rgba(15, 23, 42, 0.03), 0 1px 4px rgba(0, 0, 0, 0.01)",
    card: "0 12px 28px -8px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(0, 0, 0, 0.01)",
    elevated: "0 20px 40px -12px rgba(15, 23, 42, 0.08), 0 0 1px rgba(15, 23, 42, 0.04)",
    glow: `0 0 15px ${MAIN_COLOR_SHADOW}`,
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: "full",
        fontWeight: "bold",
        transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
      },
      variants: {
        solid: {
          bg: "brand.main",
          color: "white",
          _hover: {
            bg: "brand.main",
            opacity: 0.9,
            transform: "translateY(-1px)",
            boxShadow: "0 8px 20px rgba(142, 41, 36, 0.25)",
          },
          _active: {
            transform: "translateY(0)",
          },
        },
        outline: {
          borderColor: "gray.200",
          color: "brand.main",
          _hover: {
            bg: "brand.purpleSoft",
            borderColor: "brand.main",
          },
        },
      },
    },
    Badge: {
      baseStyle: {
        borderRadius: "full",
        px: 3,
        py: 1,
        textTransform: "none",
        fontWeight: "bold",
      },
    },
    Menu: {
      baseStyle: {
        list: {
          bg: "white",
          borderWidth: "1px",
          borderColor: "gray.100",
          boxShadow: "0 10px 25px rgba(15, 23, 42, 0.06)",
          borderRadius: "xl",
          py: 2,
          minW: "180px",
          zIndex: 100,
        },
        item: {
          bg: "transparent",
          color: "gray.700",
          fontSize: "sm",
          py: 2.5,
          px: 4,
          _hover: {
            bg: "brand.purpleSoft",
            color: "brand.main",
          },
          _focus: {
            bg: "brand.purpleSoft",
          },
        },
      },
    },
  },
});

export default theme;
